const formatMetricValue = (
  value: number | null | undefined
): string | null => {
  if (value === null) return "--";
  if (value === undefined) return null;
  return typeof value === "number" ? value.toFixed(2) : null;
};

const InlineLoader = () => (
  <span
    className="inline-block animate-spin rounded-full h-3 w-3 border-[2px] border-[#34656D] border-t-transparent align-middle"
    aria-label="Loading"
  />
);

type MetricItem = {
  label: string;
  value: number | null | undefined;
  unit: string;
};

export default function MetricChip({
  icon,
  items,
}: {
  icon?: React.ReactNode;
  items: [MetricItem] | [MetricItem, MetricItem];
}) {
  return (
    <div className="w-full sm:w-[calc(50%_-_0.5rem)] xl:flex-1 xl:w-auto h-[52px] flex hover:shadow-md transition-all ease-in-out duration-300 flex-nowrap items-center bg-white px-2 py-2 rounded-lg border-l-[3px] border-[#529BA7] shadow-sm">
      <div className="flex flex-col w-full">
        {items.map((item, index) => (
          <div
            key={index}
            className="flex items-center justify-between w-full select-none"
          >
            <span className="text-xs text-[#6F6D7C] font-normal">
              {item.label}:
            </span>

            <div className="flex items-baseline gap-1">
              {formatMetricValue(item.value) !== null ? (
                <>
                  <span className="text-xs font-medium text-[#525062]">
                    {formatMetricValue(item.value)}
                  </span>
                  {item.value !== null && (
                    <span className="text-xs font-medium text-[#525062]">
                      {item.unit}
                    </span>
                  )}
                </>
              ) : (
                <InlineLoader />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function MetricChipHead({
  icon,
  title,
  items,
}: {
  icon?: React.ReactNode;
  title?: string;
  items: [MetricItem] | [MetricItem, MetricItem];
}) {
  return (
    <div className="w-full xl:flex-1 xl:w-auto flex flex-col hover:shadow-md transition-all ease-in-out duration-300 bg-white px-2 py-2 rounded-lg border-l-[3px] border-[#529BA7] shadow-sm">
      <div className="flex flex-row gap-2 items-center mb-1 justify-left">
        <span className="text-xs font-medium text-[#34656D]">{title}</span>
      </div>
      <div className="flex flex-row items-center justify-between gap-1 w-full">
        {items.map((item, index) => (
          <div
            key={index}
            className="flex items-center gap-1 overflow-hidden"
          >
            <span className="text-xs text-[#6F6D7C] font-normal whitespace-nowrap">
              {item.label}:
            </span>
            <div className="flex items-baseline gap-1 overflow-hidden">
              {formatMetricValue(item.value) !== null ? (
                <>
                  <span className="text-xs font-medium text-[#525062]">
                    {formatMetricValue(item.value)}
                  </span>
                  {item.value !== null && (
                    <span className="text-[8px] font-medium text-[#525062] shrink-0">
                      {item.unit}
                    </span>
                  )}
                </>
              ) : (
                <InlineLoader />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
